import type ChatProvider from '../store/schema/ChatProvider';
import { getStore } from '../store/chatStore';
import { mutatorAction } from 'satcheljs';

export const setChatProvider = mutatorAction('SET_CHAT_PROVIDER', (provider: ChatProvider) => {
    getStore().chatProvider = provider;
});

export const setIsChatCalloutShown = mutatorAction(
    'SET_IS_CHAT_CALLOUT_SHOWN',
    (isShown: boolean) => {
        getStore().isChatCalloutShown = isShown;
    }
);
